import React, { useState, useEffect, useMemo } from 'react';
import { Descriptions, Button, Collapse, Modal, Image, Tag, Table, Space, Row, Col } from 'antd';
import dayjs from 'dayjs';
import { examService } from '../../../services/examService';
import { studentService } from '../../../services/studentService';

const StudentDetail = ({ student }) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImages, setPreviewImages] = useState([]);
  const [activeKeys, setActiveKeys] = useState(['1']); // Default to showing only basic info
  const [examHistory, setExamHistory] = useState({
    科目一: [],
    科目二: [],
    科目三: [],
    科目四: []
  });

  // Reset active keys when student changes or component unmounts
  useEffect(() => {
    setActiveKeys(['1']);
    console.log('student', student);
  }, [student]);

  // useEffect(() => {
  //   fetchExamHistory();
  // }, [student.objectId]);
  // useEffect(() => {
  //   // console.log('student', student);  
  //   // console.log('student notes', student.notes);
  // }, [student]);
  const fetchExamHistory = async () => {
    try {
      const [subject1, subject2, subject3, subject4] = await Promise.all([
        examService.getStudentExams(student.objectId, '科目一'),
        examService.getStudentExams(student.objectId, '科目二'),
        examService.getStudentExams(student.objectId, '科目三'),
        examService.getStudentExams(student.objectId, '科目四')
      ]);

      setExamHistory({
        科目一: subject1,
        科目二: subject2,
        科目三: subject3,
        科目四: subject4
      });
    } catch (error) {
      console.error('Fetch exam history error:', error);
    }
  };

  // Helper to extract image URLs from individual file fields
  const getReceiptPicUrls = () => {
    const urls = [];
    
    // Check if we have the receiptPics array from studentService
    if (student.receiptPics && Array.isArray(student.receiptPics)) {
      return student.receiptPics.map(pic => {
        if (pic && pic.attributes && pic.attributes.url) {
          return pic.attributes.url;
        } else if (pic && pic.url) {
          return typeof pic.url === 'function' ? pic.url() : pic.url;
        }
        return null;
      }).filter(Boolean);
    }
    
    // Check for legacy single receiptPic
    if (student.receiptPic) {
      if (student.receiptPic.attributes && student.receiptPic.attributes.url) {
        urls.push(student.receiptPic.attributes.url);
      } else if (student.receiptPic.url) {
        urls.push(typeof student.receiptPic.url === 'function' ? student.receiptPic.url() : student.receiptPic.url);
      }
    }
    
    // Check for numbered receipt pics
    const count = student.receiptPicCount || 0;
    for (let i = 1; i <= count; i++) {
      const picField = student[`receiptPic${i}`];
      if (picField) {
        if (picField.attributes && picField.attributes.url) {
          urls.push(picField.attributes.url);
        } else if (picField.url) {
          urls.push(typeof picField.url === 'function' ? picField.url() : picField.url);
        }
      }
    }
    
    return urls;
  };
  
  // Helper to extract image URLs from individual tuition receipt fields
  const getTuitionReceiptUrls = () => {
    const urls = [];
    
    // Check if we have the tuitionReceipts array from studentService
    if (student.tuitionReceipts && Array.isArray(student.tuitionReceipts)) {
      return student.tuitionReceipts.map(receipt => {
        if (receipt && receipt.attributes && receipt.attributes.url) {
          return receipt.attributes.url;
        } else if (receipt && receipt.url) {
          return typeof receipt.url === 'function' ? receipt.url() : receipt.url;
        }
        return null;
      }).filter(Boolean);
    }
    
    // Check for legacy single tuitionReceipt
    if (student.tuitionReceipt) {
      if (student.tuitionReceipt.attributes && student.tuitionReceipt.attributes.url) {
        urls.push(student.tuitionReceipt.attributes.url);
      } else if (student.tuitionReceipt.url) {
        urls.push(typeof student.tuitionReceipt.url === 'function' ? student.tuitionReceipt.url() : student.tuitionReceipt.url);
      }
    }
    
    // Check for numbered tuition receipts
    const count = student.tuitionReceiptCount || 0;
    for (let i = 1; i <= count; i++) {
      const receiptField = student[`tuitionReceipt${i}`];
      if (receiptField) {
        if (receiptField.attributes && receiptField.attributes.url) {
          urls.push(receiptField.attributes.url);
        } else if (receiptField.url) {
          urls.push(typeof receiptField.url === 'function' ? receiptField.url() : receiptField.url);
        }
      }
    }
    
    return urls;
  };

  // Helper to extract image URLs from student data for general use
  const getImageUrls = (imageField) => {
    if (!imageField) return [];
    
    // Handle array of file objects
    if (Array.isArray(imageField)) {
      return imageField.map(img => {
        if (img && img.attributes && img.attributes.url) {
          return img.attributes.url;
        } else if (img && img.url) {
          return typeof img.url === 'function' ? img.url() : img.url;
        }
        return null;
      }).filter(Boolean);
    }
    
    // Handle single file object for backward compatibility
    if (imageField.attributes && imageField.attributes.url) {
      return [imageField.attributes.url];
    } else if (imageField.url) {
      return [typeof imageField.url === 'function' ? imageField.url() : imageField.url];
    }
    
    return [];
  };

  const handlePreview = (file, title) => {
    if (file) {
      setPreviewImage(file);
      setPreviewTitle(title);
      setPreviewOpen(true);
    }
  };

  // New method to handle previewing multiple images
  const handlePreviewMultiple = (images, title) => {
    if (images && images.length > 0) {
      setPreviewImages(images);
      setPreviewTitle(title);
      setPreviewVisible(true);
    }
  };

  const calculateTotalHours = (examStudy) => {
    if (!examStudy || !examStudy.study_hour) return 0;
    return examStudy.study_hour.reduce((total, record) => total + (record.hours || 0), 0);
  };

  // 计算显示状态
  const getDisplayStatus = (student) => {
    // 先检查退证状态

    // 根据布尔值计算中间状态
    if (!student.verified) return '未审核';
    if (!student.documented) return '未审档';
    if (!student.interviewed) return '未面签';
    return student.status;  // 所有检查都通过
  };

  // 考试类型名称映射
  const EXAM_NAMES = {
    '1': '科目一',
    '2': '科目二',
    '3': '科目三',
    '4': '科目四'
  };

  // 处理考试记录的展示
  const renderExamHistory = () => {
    const exams = student.exams || [];
    
    return Object.entries(EXAM_NAMES).map(([examType, examName]) => {
      const examRecords = exams.filter(exam => exam.examType === examType);
      
      return (
        <Descriptions.Item label={examName} key={examType}>
          {examRecords.length > 0 ? (
            <ul>
              {examRecords.map((exam, index) => (
                <li key={index}>
                  <Tag color={exam.passed ? 'success' : 'error'}>
                    {exam.passed ? '通过' : '不通过'}
                  </Tag>
                  {exam.date} 考官: {exam.examiner || '-'}
                </li>
              ))}
            </ul>
          ) : '暂无记录'}
        </Descriptions.Item>
      );
    });
  };

  // Add this helper function to format minutes into hours and minutes
  const formatMinutes = (minutes) => {
    if (!minutes) return '0小时0分钟';
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours}小时${remainingMinutes}分钟`;
  };

  // Render a gallery of image thumbnails for receipt pictures
  const renderReceiptGallery = () => {
    const imageUrls = getReceiptPicUrls();
    
    if (imageUrls.length === 0) {
      return '未上传';
    }
    
    return (
      <div>
        <Button 
          type="link" 
          onClick={() => handlePreviewMultiple(imageUrls, '收据照片')}
        >
          查看收据照片（{imageUrls.length}张）
        </Button>
        <div style={{ marginTop: 8 }}>
          <Row gutter={8}>
            {imageUrls.slice(0, 3).map((url, index) => (
              <Col span={8} key={index}>
                <img 
                  src={url} 
                  alt={`收据照片 ${index + 1}`} 
                  style={{ 
                    width: '100%', 
                    height: 60, 
                    objectFit: 'cover',
                    cursor: 'pointer',
                    borderRadius: 4
                  }}
                  onClick={() => handlePreview(url, `收据照片 ${index + 1}`)}
                />
              </Col>
            ))}
            {imageUrls.length > 3 && (
              <Col span={8}>
                <div 
                  style={{ 
                    width: '100%', 
                    height: 60, 
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#f0f0f0',
                    borderRadius: 4,
                    cursor: 'pointer'
                  }}
                  onClick={() => handlePreviewMultiple(imageUrls, '收据照片')}
                >
                  +{imageUrls.length - 3}
                </div>
              </Col>
            )}
          </Row>
        </div>
      </div>
    );
  };
  
  // Render a gallery of image thumbnails for tuition receipts
  const renderTuitionReceiptGallery = () => {
    const imageUrls = getTuitionReceiptUrls();
    
    if (imageUrls.length === 0) {
      return '未上传';
    }
    
    return (
      <div>
        <Button 
          type="link" 
          onClick={() => handlePreviewMultiple(imageUrls, '支付凭证')}
        >
          查看支付凭证（{imageUrls.length}张）
        </Button>
        <div style={{ marginTop: 8 }}>
          <Row gutter={8}>
            {imageUrls.slice(0, 3).map((url, index) => (
              <Col span={8} key={index}>
                <img 
                  src={url} 
                  alt={`支付凭证 ${index + 1}`} 
                  style={{ 
                    width: '100%', 
                    height: 60, 
                    objectFit: 'cover',
                    cursor: 'pointer',
                    borderRadius: 4
                  }}
                  onClick={() => handlePreview(url, `支付凭证 ${index + 1}`)}
                />
              </Col>
            ))}
            {imageUrls.length > 3 && (
              <Col span={8}>
                <div 
                  style={{ 
                    width: '100%', 
                    height: 60, 
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#f0f0f0',
                    borderRadius: 4,
                    cursor: 'pointer'
                  }}
                  onClick={() => handlePreviewMultiple(imageUrls, '支付凭证')}
                >
                  +{imageUrls.length - 3}
                </div>
              </Col>
            )}
          </Row>
        </div>
      </div>
    );
  };

  // Define collapse items
  const collapseItems = [
    {
      key: '1',
      label: '基本信息',
      children: (
        <Descriptions bordered column={2}>
          <Descriptions.Item label="民族">{student.ethnicity || '-'}</Descriptions.Item>
          <Descriptions.Item label="生日">{student.birthday || '-'}</Descriptions.Item>
          <Descriptions.Item label="VIP">{student.VIP ? '是' : '否'}</Descriptions.Item>
          <Descriptions.Item label="本地学员">{student.local ? '是' : '否'}</Descriptions.Item>
          <Descriptions.Item label="审核状态">{student.verified ? '已审核' : '未审核'}</Descriptions.Item>
          <Descriptions.Item label="审档状态">{student.documented ? '已审档' : '未审档'}</Descriptions.Item>
          <Descriptions.Item label="面签状态">{student.interviewed ? '已面签' : '未面签'}</Descriptions.Item>
          <Descriptions.Item label="学员状态">
            {getDisplayStatus(student)}
          </Descriptions.Item>
          <Descriptions.Item label="转入学员">{student.transferred ? '是' : '否'}</Descriptions.Item>
        </Descriptions>
      )
    },
    {
      key: '2',
      label: '缴费信息',
      children: (
        <Descriptions bordered column={2}>
          <Descriptions.Item label="缴费状态">{student.paid ? '已缴费' : '未缴费'}</Descriptions.Item>
          <Descriptions.Item label="缴费方式">{student.paymentMethod || '未交款'}</Descriptions.Item>
          <Descriptions.Item label="学费金额">
            {typeof student.tuitionFee === 'number' ? student.tuitionFee : 0} 元
          </Descriptions.Item>
          <Descriptions.Item label="收据号">{student.receiptNumber || '-'}</Descriptions.Item>
          <Descriptions.Item label="收据照片">
            {renderReceiptGallery()}
          </Descriptions.Item>
          <Descriptions.Item label="支付凭证">
            {renderTuitionReceiptGallery()}
          </Descriptions.Item>
          <Descriptions.Item label="推荐人">{student.referrer || '-'}</Descriptions.Item>
        </Descriptions>
      )
    },
    {
      key: '3',
      label: '考试记录',
      children: (
        <Descriptions bordered column={1}>
          {renderExamHistory()}
        </Descriptions>
      )
    },
    {
      key: '4',
      label: '学时信息',
      children: (
        <Descriptions bordered column={1}>
          {[1, 2, 3, 4].map(examNum => {
            const subjectData = student[`subject${examNum}`];
            if (!subjectData) return null;

            return (
              <Descriptions.Item label={`科目${examNum}学时`} key={examNum}>
                <div>
                  学时: {formatMinutes(subjectData.minutes)}
                  {subjectData.kilometers !== undefined && 
                    `, 里程: ${subjectData.kilometers}公里`}
                </div>
                <div>
                  完成状态: {student[`subject${examNum}Completed`] ? '已完成' : '未完成'}
                </div>
              </Descriptions.Item>
            );
          })}
        </Descriptions>
      )
    },
    {
      key: '5',
      label: '备注信息',
      children: (
        <Descriptions bordered column={1}>
          <Descriptions.Item label="备注">
            {student.notes?.length > 0 ? (
              <ul>
                {student.notes.map((note, index) => (
                  <li key={index}>
                    {note.content}
                    <span style={{ color: '#888', marginLeft: 8, fontSize: '0.9em' }}>
                      ({dayjs(note.date).format('YYYY-MM-DD HH:mm')})
                    </span>
                  </li>
                ))}
              </ul>
            ) : '无备注'}
          </Descriptions.Item>
        </Descriptions>
      )
    },
    {
      key: '6',
      label: '退证信息',
      children: student.status === '退学' ? (
        <Descriptions bordered column={2}>
          <Descriptions.Item label="退证日期">
            {student.withdrawDate || '-'}
          </Descriptions.Item>
          <Descriptions.Item label="退证原因">
            {student.withdrawReason || '-'}
          </Descriptions.Item>
          <Descriptions.Item label="退证收据">
            {student.withdrawReceipt?.attributes ? (
              <Button 
                type="link" 
                onClick={() => handlePreview(student.withdrawReceipt.attributes.url, '退证收据')}
              >
                查看退证收据
              </Button>
            ) : '未上传'}
          </Descriptions.Item>
        </Descriptions>
      ) : (
        <div>该学员未退学</div>
      )
    }
  ];

  return (
    <div>
      <Descriptions bordered column={2}>
        <Descriptions.Item label="姓名">{student.name || '-'}</Descriptions.Item>
        <Descriptions.Item label="身份证号">{student.uniqueId || '-'}</Descriptions.Item>
        <Descriptions.Item label="手机号">{student.phone || '-'}</Descriptions.Item>
        <Descriptions.Item label="档案号">{student.fileId || '-'}</Descriptions.Item>
        <Descriptions.Item label="报名日期">{student.signUpDate || '-'}</Descriptions.Item>
        <Descriptions.Item label="性别">{student.gender || '-'}</Descriptions.Item>
        <Descriptions.Item label="地址">{student.address || '-'}</Descriptions.Item>
      </Descriptions>

      <Collapse 
        style={{ marginTop: 16 }} 
        items={collapseItems} 
        activeKey={activeKeys}
        onChange={setActiveKeys}
      />

      {/* Single image preview modal */}
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={() => setPreviewOpen(false)}
      >
        <Image
          alt={previewTitle}
          style={{ width: '100%' }}
          src={previewImage}
          preview={false}
        />
      </Modal>

      {/* Multiple images preview modal */}
      <Modal
        open={previewVisible}
        title={previewTitle}
        footer={null}
        width={800}
        onCancel={() => setPreviewVisible(false)}
      >
        <div style={{ marginTop: 16 }}>
          <Image.PreviewGroup>
            <Row gutter={[16, 16]}>
              {previewImages.map((src, index) => (
                <Col span={8} key={index}>
                  <Image
                    src={src}
                    alt={`${previewTitle} ${index + 1}`}
                    style={{ width: '100%', objectFit: 'cover' }}
                  />
                </Col>
              ))}
            </Row>
          </Image.PreviewGroup>
        </div>
      </Modal>
    </div>
  );
};

export default StudentDetail; 